<template>
  <div class="animated fadeIn">
    <SubHeaderManageApprovedDashBoard :fixElement="fixElement" :class="{'fix-element-to-top': fixElement}"
                                      :pagingObj="pagingObj" :eventStatus="tableType"
                                      :sliderValue="sliderValue"
                                      :textSearch="textSearch"
                                      :listChecked="dataSort"
                                      :list-filtered="dataFilter"
                                      @TEXT_SEARCH_CHANGE="handleTextSearchChange"
                                      @CHANGE_FILTER_OPTION="handleChangeDataSort"
                                      @CHANGE_FILTER_STATUS_OPTION="handleChangeDataFilter"
                                      @SLIDER_CHANGE_VALUE="handleSliderChangeValue"></SubHeaderManageApprovedDashBoard>
    <div :style="{'height': fixElement ? getHeightOfComp + 'px' : '0px'}"></div>
    <Manage :loading="getLoading"
            ref="listEventByClients"
            :dateOut="sliderValue"
            :filterBy="dataFilter"
            :sortBy="dataSort"
            :textSearch="textSearch"></Manage>
  </div>
</template>

<script>
import SubHeaderManageApprovedDashBoard from '../../components/subHeaders/SubHeaderManageApprovedDashBoard'
import Manage from '../../components/eventManagement/manage/Manage';
import consts from '../../_consts';
import {mapGetters} from 'vuex';

export default {
  name: 'manage-approved',
  components: {
    Manage,
    SubHeaderManageApprovedDashBoard
  },
  computed: {
    getHeightOfComp () {
      return 54;
    },
    ...mapGetters({
      getLoading: 'GETTERS_IS_LOADING'
    })
  },
  data () {
    return {
      fixElement: false,
      sliderValue: ['0', '60+'],
      dataSort: ['dateTime'],
      dataFilter: ['APPROVED'],
      textSearch: this.$route.params.textSearch || '',
      listEventByClients: []
    }
  },
  methods: {
    handleScroll () {
      this.fixElement = window.scrollY >= 180;
    },
    handleSliderChangeValue (data) {
      this.sliderValue = data;
    },
    handleChangeDataSort (data) {
      this.dataSort = data;
    },
    handleChangeDataFilter (data) {
      this.dataFilter = data;
    },
    handleTextSearchChange (textSearch) {
      this.textSearch = textSearch;
    }
  },
  created () {
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', consts.viewNames.manageApprovedDashboard);
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted () {
    this.textSearch = this.$route.params.textSearch || '';
    if (this.$route.params.filter) {
      this.dataFilter = this.$route.params.filter.split(',');
    }
    if (this.$route.params.sort) {
      this.dataSort = this.$route.params.sort.split(',');
    }
    if (this.$route.params.dateSliderValue) {
      let ar = this.$route.params.dateSliderValue.split(',');
      this.sliderValue = ar;
    }
  }
};
</script>


<style>
  .fix-element-to-top{
    position: fixed;
    top: 0;
    z-index: 1000;
    height: 54px;
  }
</style>



// WEBPACK FOOTER //
// ManageApproved.vue?fcd318ae